jQuery(document).ready(function (jQuery) {

  // jQuery(window).on('load', function() {
  //           jQuery('.videoply')[0].play();
  //       });
  /*if(performance.navigation.type == 2){
     location.reload(true);
  }*/
  if (localStorage.getItem("openCartDrawer") === "true") {
    // Remove the flag
    localStorage.removeItem("openCartDrawer");

    // Open the mini cart drawer
    document.getElementsByTagName("cart-drawer")[0].open();
  }
  jQuery(".announcement-slider").slick({
    infinite:true,
    slidesToShow: 7,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  jQuery(".common-slider").owlCarousel({
    items: 4,
    margin: 30,
    dots: false,
    nav: false,
    loop: true,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 5000,
    autoplaySpeed: 5000,
    autoplayHoverPause: true,
    navText: [],
    responsive: {
      0: {
        items: 1,
        margin: 5,
      },
      576: {
        items: 1,
        margin: 10,
      },
      768: {
        items: 2,
        margin: 20,
      },
      1000: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1740: {
        items: 4,
      },
    },
  });
  jQuery(".home-slider-section .home-slider ul").owlCarousel({
    margin: 30,
    dots: false,
    nav: false,
    loop: true,
    autoplay: true,
    items: 5,
    navText: [],
    responsive: {
      0: {
        items: 1,
        margin: 5,
      },
      576: {
        items: 2,
        margin: 10,
      },
      990: {
        items: 3,
        margin: 20,
      },
      1400: {
        items: 4,
      },
      1840: {
        items: 5,
      },
    },
  });

  jQuery(".testi-slider").owlCarousel({
    margin: 30,
    dots: true,
    nav: false,
    loop: true,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 7000,
    autoplaySpeed: 7000,
    // autoplayHoverPause: true,
    items: 4,
    navText: [],
    responsive: {
      0: {
        items: 1,
        margin: 20,
      },
      576: {
        items: 2,
        margin: 20,
      },
      768: {
        items: 3,
        margin: 20,
      },
      1000: {
        items: 4,
      },
    },
  });

  jQuery(".product-result-slider").owlCarousel({
    margin: 30,
    dots: true,
    nav: false,
    items: 2,
    navText: [],
    responsive: {
      0: {
        items: 1,
        margin: 5,
      },
      576: {
        items: 1,
        margin: 10,
      },
      768: {
        items: 2,
        margin: 20,
      },
      1000: {
        items: 3,
      },
    },
  });

  jQuery(".product-slider").owlCarousel({
    margin: 30,
    dots: false,
    nav: false,
    navText: [],
    responsive: {
      0: {
        items: 1,
        margin: 10,
        dots:true,
      },
      650: {
        items: 2,
        margin: 10,
      },
      768: {
        items: 2,
        margin: 20,
      },
      1000: {
        items: 3,
      },
    },
  });

  
});

jQuery("body").on("click", ".load-morewrap a", function (e) {
    e.preventDefault();
    var data_href = jQuery(this).attr("href");
    //console.log(data_href);
    jQuery.ajax({
      url: data_href,
      type: "GET",
      beforeSend: function () {
        jQuery("#loader").show();
      },
      success: function (data) {
        jQuery("#loadmorenews").append(
          jQuery(data).find("#loadmorenews").html()
        );
        var paginationData = jQuery(data).find(".load-morewrap").html();
        if (typeof paginationData === "undefined") {
          jQuery(".load-morewrap").html("");
        } else {
          jQuery(".load-morewrap").html(
            jQuery(data).find(".load-morewrap").html()
          );
        }
        jQuery("#loader").hide();
      },
    });
  });

// for toggle menu-----------------------------------
jQuery("#key-ingredients").click(function () {
  jQuery("body").toggleClass("sidebar-show");
});
jQuery(".hamburger-nav-close").click(function () {
  jQuery("body").removeClass("sidebar-show");
});

jQuery(".add-to-cart-form").click(function() {
  jQuery("body").addClass("changeCursor");
});
 jQuery(".drawer__close").click(function() {
jQuery("body").removeClass("changeCursor");
});

jQuery("#cart-icon-bubble").click(function() {
jQuery("body").addClass("side-cart-bar-show");
});

jQuery('body').on('click', ".drawer .drawer__close", function() {
  jQuery("body").removeClass("side-cart-bar-show");
});

jQuery("body").on("click", ".addtoincart", async function (e) {
  e.preventDefault();
  var product_id = jQuery(this).attr("data-product_id");
  var line = parseInt(jQuery(this).attr("data-line_item"));
  var selling_plan = jQuery(this).attr("data-subs_plan_id");
  var quantity = parseInt(jQuery('#CartDrawer-Item-' + line + ' .quantity__input').val());
  jQuery('#CartDrawer-Item-' + line + ' .loading__spinner').removeClass('hidden');
  // Ensure we have a product ID to update the cart
  if (!product_id) {
    console.error('No product ID found');
    return;
  }

  let updates = {
    'id': product_id,
    'quantity': quantity,
    'selling_plan': selling_plan
  };

  // Update the cart
  try {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: updates,
      success: async function(data) {
        console.log('Cart updated:', data);
        try {
          const response = await fetch('/');
          const textData = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(textData, 'text/html');
          const cartDrawerContent = doc.querySelector('.drawer').innerHTML;
          document.querySelector('.drawer').innerHTML = cartDrawerContent;
          const cartIcon = doc.querySelector('#cart-icon-bubble').innerHTML;
          document.querySelector('#cart-icon-bubble').innerHTML = cartIcon;
          // Open the cart drawer
          document.querySelector('#cart-icon-bubble').click();
        } catch (error) {
          console.error("Error fetching cart:", error);
          // Handle error (optional)
        }
      },
      error: function(error) {
        console.log('Error updating cart', error);
      }
    });
  } catch (error) {
    console.error('Error:', error);
  }
});



function updateCartUI(item) {
  // Update cart count
  $.getJSON('/cart.js', function(cart) {
    $('#cart-count').text(cart.item_count);
  });

  // Optionally update other parts of the cart UI
  // For example, a mini cart or cart drawer
}
async function fetchAndReplaceHtml(newContentBlock) {
    const url = window.Shopify.routes.root + 'cart?section_id=main-cart-items';
    try {
        const response = await fetch(url);
        const responseText = await response.text();
        const newHtml = new DOMParser().parseFromString(responseText, "text/html").getElementById('main-cart-items').innerHTML;
        document.getElementById(newContentBlock).innerHTML = newHtml;
        document.getElementsByTagName('cart-drawer')[0].open();
    } catch (error) {
        console.error("Error fetching and replacing HTML:", error);
    }
}

async function updateCartSubtotal() {
    const url = window.Shopify.routes.root + 'cart.js';
    try {
        const response = await fetch(url);
        const data = await response.json();
        const newSubtotal = data.total_price / 100; // Assuming the price is in cents

        console.log("Updated cart subtotal:", newSubtotal);

        // Update the cart subtotal element
        const subtotalElements = document.getElementsByClassName('totals__total-value');
        if (subtotalElements.length > 0) {
            for (let i = 0; i < subtotalElements.length; i++) {
                subtotalElements[i].textContent = `$${newSubtotal.toFixed(2)}`;
            }
            console.log("Subtotal updated to:", `$${newSubtotal.toFixed(2)}`);
        } else {
            console.error("Cart subtotal element not found.");
        }
    } catch (error) {
        console.error("Error updating cart subtotal:", error);
    }
}


  // jQuery(window).on('load', function() {
  //   var html5Video = jQuery('#html5-video-{{ video.id }}');
  //   if (html5Video) {
  //     html5Video.play();
  //   }
  // });

